/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export enum ActivityType {
  ProjectCreated = 'project_created',
  ProjectNoteAdded = 'project_note_added',
  ProjectStateChanged = 'project_state_changed',
  ProjectVisibilityChanged = 'project_visibility_changed'
}

export type AppVersion = {
  __typename?: 'AppVersion';
  android?: Maybe<Scalars['String']['output']>;
  iOS?: Maybe<Scalars['String']['output']>;
};

export type ApproveReportInput = {
  id: Scalars['ID']['input'];
};

export type ApproveReportResponse = MutationResponse & {
  __typename?: 'ApproveReportResponse';
  success: Scalars['Boolean']['output'];
};

export type AuthUser = {
  __typename?: 'AuthUser';
  email: Scalars['String']['output'];
  family_name: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  opencart_customer_id?: Maybe<Scalars['Int']['output']>;
  phone_number: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type Avatar = {
  __typename?: 'Avatar';
  url: Scalars['String']['output'];
};

export type BlockInput = {
  user_id: Scalars['ID']['input'];
};

export type BlockResponse = MutationResponse & {
  __typename?: 'BlockResponse';
  success: Scalars['Boolean']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  author: CommunityAuthor;
  body: Scalars['String']['output'];
  comments?: Maybe<Array<Comment>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  own_reaction?: Maybe<ReactionType>;
  post_id: Scalars['ID']['output'];
  published_at: Scalars['String']['output'];
  reaction_counts: ReactionCounts;
  reactions?: Maybe<Array<Reaction>>;
};

export type CommentsResponse = {
  __typename?: 'CommentsResponse';
  comments: Array<Comment>;
  cursor?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
};

export type CommerceQueries = {
  __typename?: 'CommerceQueries';
  sales?: Maybe<SaleQueries>;
  stores?: Maybe<StoresQueries>;
};

export type CommunityAuthor = {
  __typename?: 'CommunityAuthor';
  avatar?: Maybe<Avatar>;
  avatar_url: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_blocking: Scalars['Boolean']['output'];
  is_following: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type CommunityMutations = {
  __typename?: 'CommunityMutations';
  block?: Maybe<BlockResponse>;
  createComment?: Maybe<Comment>;
  createImageUploadOptions?: Maybe<ImageUploadOptions>;
  createPost?: Maybe<Post>;
  createReaction?: Maybe<CreateReactionResponse>;
  deleteComment?: Maybe<DeleteCommentResponse>;
  deletePost?: Maybe<DeletePostResponse>;
  deleteReaction?: Maybe<DeleteReactionResponse>;
  follow?: Maybe<FollowResponse>;
  reportComment?: Maybe<ReportResponse>;
  reportPost?: Maybe<ReportResponse>;
  reportProfile?: Maybe<ReportResponse>;
  unblock?: Maybe<BlockResponse>;
  unfollow?: Maybe<FollowResponse>;
  updateComment?: Maybe<Comment>;
  updatePost?: Maybe<Post>;
};


export type CommunityMutationsBlockArgs = {
  input?: InputMaybe<BlockInput>;
};


export type CommunityMutationsCreateCommentArgs = {
  input?: InputMaybe<CreateCommentInput>;
};


export type CommunityMutationsCreateImageUploadOptionsArgs = {
  input?: InputMaybe<UploadImageInput>;
};


export type CommunityMutationsCreatePostArgs = {
  context?: InputMaybe<ContextInput>;
  input?: InputMaybe<CreatePostInput>;
};


export type CommunityMutationsCreateReactionArgs = {
  input?: InputMaybe<CreateReactionInput>;
};


export type CommunityMutationsDeleteCommentArgs = {
  comment_id: Scalars['ID']['input'];
};


export type CommunityMutationsDeletePostArgs = {
  post_id: Scalars['ID']['input'];
};


export type CommunityMutationsDeleteReactionArgs = {
  input?: InputMaybe<DeleteReactionInput>;
};


export type CommunityMutationsFollowArgs = {
  input?: InputMaybe<FollowInput>;
};


export type CommunityMutationsReportCommentArgs = {
  input?: InputMaybe<ReportCommentInput>;
};


export type CommunityMutationsReportPostArgs = {
  input?: InputMaybe<ReportPostInput>;
};


export type CommunityMutationsReportProfileArgs = {
  input?: InputMaybe<ReportProfileInput>;
};


export type CommunityMutationsUnblockArgs = {
  input?: InputMaybe<BlockInput>;
};


export type CommunityMutationsUnfollowArgs = {
  input?: InputMaybe<FollowInput>;
};


export type CommunityMutationsUpdateCommentArgs = {
  input?: InputMaybe<UpdateCommentInput>;
};


export type CommunityMutationsUpdatePostArgs = {
  input?: InputMaybe<UpdatePostInput>;
};

export type CommunityQueries = {
  __typename?: 'CommunityQueries';
  comment?: Maybe<Comment>;
  comments?: Maybe<CommentsResponse>;
  followers?: Maybe<FollowersResponse>;
  following?: Maybe<FollowingResponse>;
  post?: Maybe<Post>;
  posts?: Maybe<PostsResponse>;
  profile?: Maybe<Profile>;
  reactions?: Maybe<ReactionsResponse>;
  replies?: Maybe<CommentsResponse>;
  reportReasons: Array<ReportReason>;
};


export type CommunityQueriesCommentArgs = {
  id: Scalars['ID']['input'];
};


export type CommunityQueriesCommentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  post_id: Scalars['ID']['input'];
};


export type CommunityQueriesFollowersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};


export type CommunityQueriesFollowingArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};


export type CommunityQueriesPostArgs = {
  id: Scalars['ID']['input'];
};


export type CommunityQueriesPostsArgs = {
  context?: InputMaybe<ContextInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type CommunityQueriesProfileArgs = {
  user_id: Scalars['ID']['input'];
};


export type CommunityQueriesReactionsArgs = {
  input: GetReactionsInput;
};


export type CommunityQueriesRepliesArgs = {
  comment_id: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Competition = {
  __typename?: 'Competition';
  body: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  lead?: Maybe<CompetitionParticipant>;
  own_participant?: Maybe<CompetitionParticipant>;
  participants_count: Scalars['Int']['output'];
  period: CompetitionPeriod;
  slug: Scalars['String']['output'];
  start_date: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompetitionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language: LanguageType;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionMutations = {
  __typename?: 'CompetitionMutations';
  createParticipant?: Maybe<CompetitionParticipant>;
  createVote?: Maybe<CreateCompetitionParticipantVoteResponse>;
  deleteVote?: Maybe<DeleteCompetitionParticipantVoteResponse>;
};


export type CompetitionMutationsCreateParticipantArgs = {
  input: CreateCompetitionParticipantInput;
};


export type CompetitionMutationsCreateVoteArgs = {
  participant_id: Scalars['ID']['input'];
};


export type CompetitionMutationsDeleteVoteArgs = {
  participant_id: Scalars['ID']['input'];
};

export type CompetitionParticipant = {
  __typename?: 'CompetitionParticipant';
  id: Scalars['ID']['output'];
  own_vote: Scalars['Boolean']['output'];
  post: Post;
  post_id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  user: CommunityAuthor;
  user_id: Scalars['ID']['output'];
  votes_count: Scalars['Int']['output'];
};

export type CompetitionParticipantInput = {
  entry_id: Scalars['ID']['input'];
};

export type CompetitionParticipantsInput = {
  competition_id: Scalars['ID']['input'];
};

export type CompetitionParticipantsResponse = {
  __typename?: 'CompetitionParticipantsResponse';
  next_page?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  participants: Array<CompetitionParticipant>;
  total: Scalars['Int']['output'];
};

export enum CompetitionParticipantsSortBy {
  Id = 'id',
  VotesCount = 'votes_count'
}

export enum CompetitionParticipantsSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type CompetitionParticipantsSortInput = {
  order?: InputMaybe<CompetitionParticipantsSortDirection>;
  sort?: InputMaybe<CompetitionParticipantsSortBy>;
};

export enum CompetitionPeriod {
  Current = 'current',
  Old = 'old',
  Upcoming = 'upcoming'
}

export type CompetitionQueries = {
  __typename?: 'CompetitionQueries';
  competition?: Maybe<Competition>;
  competitions?: Maybe<CompetitionsResponse>;
  participant?: Maybe<CompetitionParticipant>;
  participants?: Maybe<CompetitionParticipantsResponse>;
};


export type CompetitionQueriesCompetitionArgs = {
  input?: InputMaybe<CompetitionInput>;
};


export type CompetitionQueriesCompetitionsArgs = {
  filter: CompetitionsFilterInput;
  paginate?: InputMaybe<CursorPaginationInput>;
};


export type CompetitionQueriesParticipantArgs = {
  input?: InputMaybe<CompetitionParticipantInput>;
};


export type CompetitionQueriesParticipantsArgs = {
  input?: InputMaybe<CompetitionParticipantsInput>;
  paginate?: InputMaybe<SimplePaginationInput>;
  sort?: InputMaybe<CompetitionParticipantsSortInput>;
};

export type CompetitionsFilterInput = {
  language: LanguageType;
  period?: InputMaybe<CompetitionPeriod>;
};

export type CompetitionsResponse = {
  __typename?: 'CompetitionsResponse';
  competitions: Array<Competition>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type Content = Pattern;

export type Context = {
  __typename?: 'Context';
  entity?: Maybe<EntityType>;
  entity_id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<KindType>;
  language?: Maybe<LanguageType>;
};

export type ContextIndexInput = {
  entity?: InputMaybe<EntityType>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<KindType>;
  language?: InputMaybe<LanguageType>;
};

export type ContextInput = {
  entity?: InputMaybe<EntityType>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<KindType>;
  language: LanguageType;
};

export type ContextSearchInput = {
  entity?: InputMaybe<EntityType>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<KindType>;
  language?: InputMaybe<LanguageType>;
};

export type CountryConfig = {
  __typename?: 'CountryConfig';
  bingoId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  legacyStore?: Maybe<Store>;
  legacyStoreId?: Maybe<Scalars['Int']['output']>;
  shopifyConfig?: Maybe<ShopifyConfig>;
  trackingId?: Maybe<Scalars['String']['output']>;
};

export type CountryConfigInput = {
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export enum CraftType {
  Both = 'both',
  Crochet = 'crochet',
  Knit = 'knit',
  Macrame = 'macrame'
}

export type CrafterMutations = {
  __typename?: 'CrafterMutations';
  fileUploadCreate?: Maybe<FileUpload>;
  surveyResponseCreate?: Maybe<SurveyResponseCreateResponse>;
  surveyResponseSave?: Maybe<SurveyResponseSaveResponse>;
  userPatternSave?: Maybe<HobbiiPatternSaveResponse>;
  userProductCreate?: Maybe<Product>;
  userProductDelete?: Maybe<ProductDeleteResponse>;
  userProductUpdate?: Maybe<Product>;
  userProjectAssignProduct?: Maybe<Project>;
  userProjectAssignYarn?: Maybe<Project>;
  userProjectCreate?: Maybe<Project>;
  userProjectUpdate?: Maybe<Project>;
  userProjectUpdateProgress?: Maybe<ProjectNote>;
  userYarnCreate?: Maybe<Yarn>;
  userYarnDelete?: Maybe<YarnDeleteResponse>;
  userYarnUpdate?: Maybe<Yarn>;
  /**
   * Adds a product to a specific wishlist. Requires either sku or product_group_identifier.
   * Returns the created wishlist item or validation errors if the operation fails.
   */
  wishlistAddItem?: Maybe<WishlistAddItemResponse>;
  /**
   * Adds a product to the user's default wishlist. Requires either sku or product_group_identifier.
   * @deprecated Use `wishlistAddItem` with a specific wishlistId instead.
   */
  wishlistAddProduct?: Maybe<WishlistItem>;
  /**
   * Creates a new wishlist with the given name and optional description.
   * Returns the created wishlist or validation errors if the operation fails.
   */
  wishlistCreate?: Maybe<WishlistCreateResponse>;
  /**
   * Deletes a wishlist and all its items. The default wishlist cannot be deleted.
   * Returns success status indicating whether the operation succeeded.
   */
  wishlistDelete?: Maybe<SuccessResponse>;
  /**
   * Removes an item from a specific wishlist.
   * Returns success status or validation errors if the operation fails.
   */
  wishlistRemoveItem?: Maybe<WishlistRemoveItemResponse>;
  /**
   * Removes a product from the user's default wishlist.
   * @deprecated Use `wishlistRemoveItem` instead.
   */
  wishlistRemoveProduct?: Maybe<SuccessResponse>;
  /**
   * Reorders an item within a wishlist to a new position.
   * The order parameter specifies the new position (0-based index).
   * Returns success status or validation errors if the operation fails.
   */
  wishlistReorderItems?: Maybe<WishlistReorderItemsResponse>;
  /**
   * Updates an existing wishlist's name and/or description.
   * At least one field (name or description) must be provided.
   * Returns the updated wishlist or validation errors if the operation fails.
   */
  wishlistUpdate?: Maybe<WishlistUpdateResponse>;
};


export type CrafterMutationsFileUploadCreateArgs = {
  input: FileUploadCreateInput;
};


export type CrafterMutationsSurveyResponseCreateArgs = {
  input: SurveyResponseCreateInput;
};


export type CrafterMutationsSurveyResponseSaveArgs = {
  input: SurveyResponseSaveInput;
};


export type CrafterMutationsUserPatternSaveArgs = {
  input: HobbiiPatternSaveInput;
};


export type CrafterMutationsUserProductCreateArgs = {
  input: ProductCreateInput;
};


export type CrafterMutationsUserProductDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterMutationsUserProductUpdateArgs = {
  input: ProductUpdateInput;
};


export type CrafterMutationsUserProjectAssignProductArgs = {
  input: ProjectAssignProductInput;
};


export type CrafterMutationsUserProjectAssignYarnArgs = {
  input: ProjectAssignYarnInput;
};


export type CrafterMutationsUserProjectCreateArgs = {
  input: ProjectCreateInput;
};


export type CrafterMutationsUserProjectUpdateArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ProjectUpdateInput>;
};


export type CrafterMutationsUserProjectUpdateProgressArgs = {
  input: ProjectProgressUpdateInput;
};


export type CrafterMutationsUserYarnCreateArgs = {
  input: YarnCreateInput;
};


export type CrafterMutationsUserYarnDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterMutationsUserYarnUpdateArgs = {
  input: YarnUpdateInput;
};


export type CrafterMutationsWishlistAddItemArgs = {
  product_group_identifier?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  wishlistId?: InputMaybe<Scalars['ID']['input']>;
};


export type CrafterMutationsWishlistAddProductArgs = {
  product_group_identifier?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type CrafterMutationsWishlistCreateArgs = {
  input: WishlistCreateInput;
};


export type CrafterMutationsWishlistDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterMutationsWishlistRemoveItemArgs = {
  itemId: Scalars['ID']['input'];
  wishlistId: Scalars['ID']['input'];
};


export type CrafterMutationsWishlistRemoveProductArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterMutationsWishlistReorderItemsArgs = {
  itemId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  wishlistId: Scalars['ID']['input'];
};


export type CrafterMutationsWishlistUpdateArgs = {
  id: Scalars['ID']['input'];
  input: WishlistUpdateInput;
};

export type CrafterQueries = {
  __typename?: 'CrafterQueries';
  patternSuggestionsForYarn?: Maybe<HobbiiPatternsResponse>;
  publicProject?: Maybe<PublicProject>;
  publicProjects?: Maybe<PublicProjectsResponse>;
  publicWishlist?: Maybe<PublicWishlistResponse>;
  userPatternMatchDetails?: Maybe<UserPatternMatchDetailsResponse>;
  userPatternSuggestions?: Maybe<HobbiiPatternsResponse>;
  userPatterns?: Maybe<PatternsResponse>;
  userProduct?: Maybe<Product>;
  userProducts?: Maybe<ProductsResponse>;
  userProject?: Maybe<Project>;
  userProjects?: Maybe<ProjectsResponse>;
  userWishlist?: Maybe<WishlistResponse>;
  userWishlistItem?: Maybe<WishlistItem>;
  userYarn?: Maybe<Yarn>;
  userYarnSuggestions?: Maybe<SuggestedYarnResponse>;
  userYarns?: Maybe<YarnsResponse>;
  /**
   * Retrieves a specific wishlist by ID for the authenticated user.
   * Returns the wishlist with all its items included.
   */
  wishlist?: Maybe<Wishlist>;
  /**
   * Retrieves paginated items for a specific wishlist.
   * Use this query to fetch items separately when you don't need the full wishlist details.
   */
  wishlistItems?: Maybe<WishlistItemsResponse>;
  /**
   * Retrieves all wishlists for the authenticated user with optional sorting and pagination.
   * Returns a paginated list of wishlists including the default wishlist.
   */
  wishlists?: Maybe<WishlistsResponse>;
};


export type CrafterQueriesPatternSuggestionsForYarnArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  yarnProductGroupIdentifier: Scalars['ID']['input'];
};


export type CrafterQueriesPublicProjectArgs = {
  shortId: Scalars['ID']['input'];
};


export type CrafterQueriesPublicProjectsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CrafterQueriesPublicWishlistArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CrafterQueriesUserPatternMatchDetailsArgs = {
  locale?: InputMaybe<LanguageType>;
  patternId: Scalars['ID']['input'];
};


export type CrafterQueriesUserPatternSuggestionsArgs = {
  cost?: InputMaybe<PatternCost>;
  craftTypes?: InputMaybe<Array<InputMaybe<CraftType>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  difficulties?: InputMaybe<Array<InputMaybe<PatternDifficulty>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<LanguageType>;
  min_score?: InputMaybe<Scalars['Float']['input']>;
};


export type CrafterQueriesUserPatternsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PatternFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PatternSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type CrafterQueriesUserProductArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterQueriesUserProductsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ProductSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type CrafterQueriesUserProjectArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterQueriesUserProjectsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<ProjectState>>;
};


export type CrafterQueriesUserWishlistArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CrafterQueriesUserWishlistItemArgs = {
  product: Scalars['ID']['input'];
};


export type CrafterQueriesUserYarnArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterQueriesUserYarnSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  otherCursor?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<YarnSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  suggestedCursor?: InputMaybe<Scalars['String']['input']>;
};


export type CrafterQueriesUserYarnsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<YarnFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<YarnSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type CrafterQueriesWishlistArgs = {
  id: Scalars['ID']['input'];
};


export type CrafterQueriesWishlistItemsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  wishlistId: Scalars['ID']['input'];
};


export type CrafterQueriesWishlistsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<WishlistSortBy>;
  sortDir?: InputMaybe<SortOrder>;
};

export type CreateCommentInput = {
  body: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  post_id: Scalars['ID']['input'];
};

export type CreateCompetitionParticipantInput = {
  body: Scalars['String']['input'];
  competition_id: Scalars['ID']['input'];
  images: Array<Scalars['String']['input']>;
  language: LanguageType;
};

export type CreateCompetitionParticipantVoteResponse = MutationResponse & {
  __typename?: 'CreateCompetitionParticipantVoteResponse';
  success: Scalars['Boolean']['output'];
};

export type CreatePostInput = {
  body: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateProductReviewInput = {
  body_text: Scalars['String']['input'];
  language: LanguageType;
  product_id: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReactionInput = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  post_id?: InputMaybe<Scalars['ID']['input']>;
  type: ReactionType;
};

export type CreateReactionResponse = MutationResponse & {
  __typename?: 'CreateReactionResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateRowCounterInput = {
  name: Scalars['String']['input'];
};

export type CursorPaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerContentResponse = {
  __typename?: 'CustomerContentResponse';
  content: Array<Maybe<Content>>;
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DeleteAvatarResponse = MutationResponse & {
  __typename?: 'DeleteAvatarResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteCommentResponse = MutationResponse & {
  __typename?: 'DeleteCommentResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteCompetitionParticipantVoteResponse = MutationResponse & {
  __typename?: 'DeleteCompetitionParticipantVoteResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteNotificationResponse = MutationResponse & {
  __typename?: 'DeleteNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type DeletePostResponse = MutationResponse & {
  __typename?: 'DeletePostResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteReactionInput = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  post_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteReactionResponse = MutationResponse & {
  __typename?: 'DeleteReactionResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteRowCounterResponse = MutationResponse & {
  __typename?: 'DeleteRowCounterResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult';
  deletionId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum EntityType {
  Competition = 'competition',
  Pattern = 'pattern',
  Product = 'product'
}

export type ExchangeTokenResponse = {
  __typename?: 'ExchangeTokenResponse';
  customerAccessToken?: Maybe<ShopifyCustomerAccessToken>;
  customerUserErrors?: Maybe<ShopifyCustomerUserErrors>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  file_identifier: Scalars['String']['output'];
  upload_endpoint: Scalars['String']['output'];
};

export type FileUploadCreateInput = {
  filename: Scalars['String']['input'];
};

export enum Filetype {
  Image = 'image',
  Pdf = 'pdf'
}

export type FilterItem = {
  __typename?: 'FilterItem';
  label: Scalars['String']['output'];
  results: Scalars['Int']['output'];
};

export type FilterItems = {
  __typename?: 'FilterItems';
  items?: Maybe<Array<FilterItem>>;
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterRange = {
  __typename?: 'FilterRange';
  label: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type FollowInput = {
  user_id: Scalars['ID']['input'];
};

export type FollowResponse = MutationResponse & {
  __typename?: 'FollowResponse';
  success: Scalars['Boolean']['output'];
};

export type FollowersResponse = {
  __typename?: 'FollowersResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  followers: Array<CommunityAuthor>;
  limit: Scalars['Int']['output'];
};

export type FollowingResponse = {
  __typename?: 'FollowingResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  following: Array<CommunityAuthor>;
  limit: Scalars['Int']['output'];
};

export type Gauge = {
  __typename?: 'Gauge';
  rows?: Maybe<Scalars['Int']['output']>;
  stitches?: Maybe<Scalars['Int']['output']>;
  unit: UnitSystem;
};

export type GaugeInput = {
  rows?: InputMaybe<Scalars['Int']['input']>;
  stitches?: InputMaybe<Scalars['Int']['input']>;
  unit: UnitSystem;
};

export type GetAvatarResponse = {
  __typename?: 'GetAvatarResponse';
  avatar_url?: Maybe<Scalars['String']['output']>;
};

export type GetNotificationsInput = {
  language: LanguageType;
  paginate?: InputMaybe<CursorPaginationInput>;
};

export type GetReactionsInput = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  post_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ReactionType>;
};

export type HobbiiPattern = {
  __typename?: 'HobbiiPattern';
  craft_type?: Maybe<CraftType>;
  difficulty?: Maybe<PatternDifficulty>;
  id: Scalars['ID']['output'];
  image?: Maybe<ProductImage>;
  is_free: Scalars['Boolean']['output'];
  match?: Maybe<YarnMatch>;
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  yarn_count?: Maybe<Scalars['Int']['output']>;
  yarns?: Maybe<Array<Maybe<HobbiiYarnVariant>>>;
};

export type HobbiiPatternSaveInput = {
  locale: LanguageType;
  pattern_id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type HobbiiPatternSaveResponse = {
  __typename?: 'HobbiiPatternSaveResponse';
  pattern?: Maybe<UserPattern>;
  userErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type HobbiiPatternsResponse = {
  __typename?: 'HobbiiPatternsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  patterns?: Maybe<Array<HobbiiPattern>>;
};

export type HobbiiYarn = {
  __typename?: 'HobbiiYarn';
  brand?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  crochet_gauge?: Maybe<Gauge>;
  id: Scalars['ID']['output'];
  knitting_gauge?: Maybe<Gauge>;
  name: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
  yarn_weight?: Maybe<Scalars['String']['output']>;
};

export type HobbiiYarnVariant = {
  __typename?: 'HobbiiYarnVariant';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ProductImage>;
  sku: Scalars['String']['output'];
  yarn?: Maybe<HobbiiYarn>;
};

export enum ImageType {
  Jpg = 'jpg',
  Png = 'png'
}

export type ImageUploadOptions = {
  __typename?: 'ImageUploadOptions';
  file_url: Scalars['String']['output'];
  upload_endpoint: Scalars['String']['output'];
};

export enum KindType {
  Gallery = 'gallery',
  Qa = 'qa'
}

export enum LanguageType {
  Da = 'da',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fi = 'fi',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl',
  No = 'no',
  Pl = 'pl',
  Sv = 'sv'
}

export type ListProductReviewInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  language: LanguageType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  product_id: Scalars['String']['input'];
};

export type LoyaltyQueries = {
  __typename?: 'LoyaltyQueries';
  points?: Maybe<PointsResponse>;
  user?: Maybe<LoyaltyUser>;
};


export type LoyaltyQueriesPointsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltyUser = {
  __typename?: 'LoyaltyUser';
  balance: Scalars['Int']['output'];
  record?: Maybe<UserLoyaltyPointsRecordResponse>;
};


export type LoyaltyUserRecordArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum MatchLabel {
  ExcellentMatch = 'excellent_match',
  GoodMatch = 'good_match',
  NoMatch = 'no_match',
  PartialMatch = 'partial_match',
  PerfectMatch = 'perfect_match',
  PoorMatch = 'poor_match'
}

export type ModerationMutations = {
  __typename?: 'ModerationMutations';
  approveReport?: Maybe<ApproveReportResponse>;
  rejectReport?: Maybe<RejectReportResponse>;
};


export type ModerationMutationsApproveReportArgs = {
  input: ApproveReportInput;
};


export type ModerationMutationsRejectReportArgs = {
  input: RejectReportInput;
};

export type ModerationPostsInput = {
  missing_answer?: InputMaybe<Scalars['Boolean']['input']>;
  newest_first?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModerationPostsResponse = SimplePaginationResponse & {
  __typename?: 'ModerationPostsResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  posts: Array<Post>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ModerationQueries = {
  __typename?: 'ModerationQueries';
  posts?: Maybe<ModerationPostsResponse>;
  reports?: Maybe<ReportsResponse>;
};


export type ModerationQueriesPostsArgs = {
  context?: InputMaybe<ContextSearchInput>;
  input?: InputMaybe<ModerationPostsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ModerationQueriesReportsArgs = {
  context?: InputMaybe<ContextSearchInput>;
  input?: InputMaybe<ReportsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type MultipassTokenResponse = {
  __typename?: 'MultipassTokenResponse';
  multipassToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  community?: Maybe<CommunityMutations>;
  competition?: Maybe<CompetitionMutations>;
  crafter?: Maybe<CrafterMutations>;
  moderation?: Maybe<ModerationMutations>;
  notification?: Maybe<NotificationMutations>;
  productReviews?: Maybe<ProductReviewsMutations>;
  toc?: Maybe<TocMutations>;
  userContent?: Maybe<UserContentMutations>;
  users?: Maybe<UsersMutations>;
};

export type MutationResponse = {
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  actor: CommunityAuthor;
  actor_id: Scalars['ID']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  notifier_id: Scalars['ID']['output'];
  read_at?: Maybe<Scalars['String']['output']>;
  sourceable_id: Scalars['String']['output'];
  sourceable_type: SourceType;
  subject: NotificationSubject;
  targetable_id: Scalars['String']['output'];
  targetable_type: TargetType;
};

export type NotificationMutations = {
  __typename?: 'NotificationMutations';
  deleteNotification?: Maybe<DeleteNotificationResponse>;
  readNotification?: Maybe<ReadNotificationResponse>;
  readNotifications?: Maybe<ReadNotificationsResponse>;
  readUserNotifications?: Maybe<ReadUserNotificationsResponse>;
  seenUserNotifications: SuccessResponse;
  unreadNotification?: Maybe<UnreadNotificationResponse>;
  unreadNotifications?: Maybe<UnreadNotificationsResponse>;
};


export type NotificationMutationsDeleteNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type NotificationMutationsReadNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type NotificationMutationsReadNotificationsArgs = {
  input?: InputMaybe<ReadNotificationsInput>;
};


export type NotificationMutationsUnreadNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type NotificationMutationsUnreadNotificationsArgs = {
  input?: InputMaybe<UnreadNotificationsInput>;
};

export type NotificationQueries = {
  __typename?: 'NotificationQueries';
  notifications: NotificationsResponse;
};


export type NotificationQueriesNotificationsArgs = {
  input: GetNotificationsInput;
};

export type NotificationSubject = Comment | Post;

export enum NotificationType {
  CommunitySimple = 'community_simple'
}

export type NotificationsResponse = {
  __typename?: 'NotificationsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  total: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
  unseen: Scalars['Int']['output'];
};

export type Pattern = {
  __typename?: 'Pattern';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sku: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum PatternCost {
  Free = 'free',
  Paid = 'paid'
}

export enum PatternDifficulty {
  Advanced = 'advanced',
  Beginner = 'beginner',
  Experienced = 'experienced',
  Intermediate = 'intermediate'
}

export type PatternFilter = FilterItems | FilterRange;

export type PatternFilterInput = {
  craft_type?: InputMaybe<Array<CraftType>>;
};

export enum PatternSortBy {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at'
}

export type PatternsResponse = {
  __typename?: 'PatternsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<PatternFilter>>;
  limit?: Maybe<Scalars['Int']['output']>;
  patterns?: Maybe<Array<UserPattern>>;
};

export type Point = {
  __typename?: 'Point';
  amount: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PointsResponse = {
  __typename?: 'PointsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  points: Array<Point>;
};

export type Post = {
  __typename?: 'Post';
  author: CommunityAuthor;
  body: Scalars['String']['output'];
  comments_count: Scalars['Int']['output'];
  context?: Maybe<Context>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  own_reaction?: Maybe<ReactionType>;
  published_at: Scalars['String']['output'];
  reaction_counts: ReactionCounts;
  teaser?: Maybe<Teaser>;
};

export type PostsResponse = {
  __typename?: 'PostsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  posts: Array<Post>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Product = {
  __typename?: 'Product';
  brand?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ProductImage>;
  location?: Maybe<Scalars['String']['output']>;
  materials?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Project>>;
  quantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductType>;
  updated_at: Scalars['String']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export type ProductCreateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  image_file_identifier?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
  variant: Scalars['String']['input'];
};

export type ProductDeleteResponse = {
  __typename?: 'ProductDeleteResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProductFilter = FilterItems | FilterRange;

export type ProductFilterInput = {
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  project?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<RangeInput>;
  type?: InputMaybe<Array<ProductType>>;
  variant?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  alt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProductReview = {
  __typename?: 'ProductReview';
  author: ReviewAuthor;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  original: ReviewTranslation;
  published_at: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  translated?: Maybe<ReviewTranslation>;
};

export type ProductReviewsMutations = {
  __typename?: 'ProductReviewsMutations';
  createReview: ProductReview;
};


export type ProductReviewsMutationsCreateReviewArgs = {
  input: CreateProductReviewInput;
};

export type ProductReviewsQueries = {
  __typename?: 'ProductReviewsQueries';
  listReviews: ProductReviewsResponse;
};


export type ProductReviewsQueriesListReviewsArgs = {
  input: ListProductReviewInput;
};

export type ProductReviewsResponse = {
  __typename?: 'ProductReviewsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  reviews: Array<ProductReview>;
};

export enum ProductSortBy {
  Brand = 'brand',
  CreatedAt = 'created_at',
  Name = 'name',
  Quantity = 'quantity',
  UpdatedAt = 'updated_at'
}

export enum ProductType {
  Accessory = 'accessory',
  Book = 'book',
  CrochetHooks = 'crochet_hooks',
  KnittingNeedles = 'knitting_needles',
  Yarn = 'yarn'
}

export type ProductUpdateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image_file_identifier?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductType>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<ProductFilter>>;
  limit?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Product>>;
};

export type Profile = {
  __typename?: 'Profile';
  followers_count: Scalars['Int']['output'];
  following_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  user: CommunityAuthor;
};

export type Project = {
  __typename?: 'Project';
  craft_type?: Maybe<CraftType>;
  created_at: Scalars['String']['output'];
  ends_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ProjectImage>;
  in_use?: Maybe<Scalars['Int']['output']>;
  is_public: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<ProjectNote>;
  pattern?: Maybe<UserPattern>;
  products?: Maybe<ProductsResponse>;
  projectActivities?: Maybe<ProjectActivitiesResponse>;
  projectNotes?: Maybe<ProjectNotesResponse>;
  published_at?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  short_id: Scalars['ID']['output'];
  started_at?: Maybe<Scalars['String']['output']>;
  state: ProjectState;
  updated_at: Scalars['String']['output'];
  yarns?: Maybe<Array<Yarn>>;
};


export type ProjectProductsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ProductSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type ProjectProjectActivitiesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type ProjectProjectNotesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectActivitiesResponse = {
  __typename?: 'ProjectActivitiesResponse';
  activities: Array<ProjectActivity>;
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type ProjectActivity = {
  __typename?: 'ProjectActivity';
  created_at: Scalars['String']['output'];
  details?: Maybe<ProjectActivityDetails>;
  note?: Maybe<ProjectNote>;
  type: ActivityType;
  updated_at: Scalars['String']['output'];
};

export type ProjectActivityDetails = ProjectStateChangeDetails | ProjectVisibilityChangeDetails;

export type ProjectAssignProductInput = {
  items: Array<ProjectAssignProductItemInput>;
  project_id: Scalars['ID']['input'];
};

export type ProjectAssignProductItemInput = {
  product_id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProjectAssignYarnInput = {
  items: Array<ProjectAssignYarnItemInput>;
  project_id: Scalars['ID']['input'];
};

export type ProjectAssignYarnItemInput = {
  quantity: Scalars['Int']['input'];
  yarn_id: Scalars['ID']['input'];
};

export type ProjectCreateInput = {
  craft_type?: InputMaybe<CraftType>;
  ends_at?: InputMaybe<Scalars['String']['input']>;
  image_file_identifier?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pattern_file_identifier?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  started_at?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ProjectState>;
};

export type ProjectFilterInput = {
  state?: InputMaybe<Array<ProjectState>>;
};

export type ProjectImage = {
  __typename?: 'ProjectImage';
  alt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProjectNote = {
  __typename?: 'ProjectNote';
  content: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<ProjectImage>>;
  rows?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['String']['output'];
};

export type ProjectNotesResponse = {
  __typename?: 'ProjectNotesResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  notes: Array<ProjectNote>;
};

export type ProjectProgressUpdateInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  image_file_identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<ProjectState>;
};

export enum ProjectState {
  Added = 'added',
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'in_progress',
  Paused = 'paused'
}

export type ProjectStateChangeDetails = {
  __typename?: 'ProjectStateChangeDetails';
  from: ProjectState;
  to: ProjectState;
};

export type ProjectUpdateInput = {
  craft_type?: InputMaybe<CraftType>;
  ends_at?: InputMaybe<Scalars['String']['input']>;
  /** Image File Identifier, from an uploaded file via the fileUploadCreate mutation. */
  image_file_identifier?: InputMaybe<Scalars['String']['input']>;
  /** Image Identifier from an existing uploaded image - from a Project Note perhaps. */
  image_id?: InputMaybe<Scalars['ID']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  started_at?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ProjectState>;
};

export type ProjectVisibilityChangeDetails = {
  __typename?: 'ProjectVisibilityChangeDetails';
  is_public: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['String']['output']>;
};

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  projects: Array<Project>;
};

export type PublicPattern = {
  __typename?: 'PublicPattern';
  craft_type?: Maybe<CraftType>;
  image?: Maybe<ProductImage>;
  name: Scalars['String']['output'];
};

export type PublicProject = {
  __typename?: 'PublicProject';
  craft_type?: Maybe<CraftType>;
  ends_at?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ProductImage>;
  name: Scalars['String']['output'];
  pattern?: Maybe<PublicPattern>;
  projectActivities?: Maybe<PublicProjectActivitiesResponse>;
  published_at: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  short_id: Scalars['ID']['output'];
  started_at?: Maybe<Scalars['String']['output']>;
  state: ProjectState;
  yarns?: Maybe<Array<PublicYarn>>;
};


export type PublicProjectProjectActivitiesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type PublicProjectActivitiesResponse = {
  __typename?: 'PublicProjectActivitiesResponse';
  activities: Array<PublicProjectActivity>;
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type PublicProjectActivity = {
  __typename?: 'PublicProjectActivity';
  created_at: Scalars['String']['output'];
  details?: Maybe<ProjectActivityDetails>;
  note?: Maybe<PublicProjectNote>;
  type: ActivityType;
  updated_at: Scalars['String']['output'];
};

export type PublicProjectNote = {
  __typename?: 'PublicProjectNote';
  content: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  images?: Maybe<Array<ProductImage>>;
  rows?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['String']['output'];
};

export type PublicProjectsResponse = {
  __typename?: 'PublicProjectsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  projects: Array<PublicProject>;
};

export type PublicWishlist = {
  __typename?: 'PublicWishlist';
  created_at: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Paginated items in this public wishlist. Use cursor and limit parameters for pagination. */
  items?: Maybe<PublicWishlistItemsResponse>;
  name: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};


export type PublicWishlistItemsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicWishlistItem = {
  __typename?: 'PublicWishlistItem';
  product_group_identifier?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** Paginated response for public wishlist items query */
export type PublicWishlistItemsResponse = {
  __typename?: 'PublicWishlistItemsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<PublicWishlistItem>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type PublicWishlistResponse = {
  __typename?: 'PublicWishlistResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  wishlist?: Maybe<PublicWishlist>;
};

export type PublicYarn = {
  __typename?: 'PublicYarn';
  brand?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  crochet_gauge?: Maybe<Gauge>;
  image?: Maybe<ProductImage>;
  knitting_gauge?: Maybe<Gauge>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  yarn_weight?: Maybe<Scalars['String']['output']>;
};

export type QaPostsInput = {
  missing_answer?: InputMaybe<Scalars['Boolean']['input']>;
  newest_first?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QaPostsResponse = {
  __typename?: 'QaPostsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  posts: Array<Post>;
};

export type QaQueries = {
  __typename?: 'QaQueries';
  posts?: Maybe<QaPostsResponse>;
  summary?: Maybe<QaSummaryResponse>;
};


export type QaQueriesPostsArgs = {
  context?: InputMaybe<ContextSearchInput>;
  input?: InputMaybe<QaPostsInput>;
  paginationInput?: InputMaybe<CursorPaginationInput>;
};


export type QaQueriesSummaryArgs = {
  context?: InputMaybe<ContextSearchInput>;
};

export type QaSummaryResponse = {
  __typename?: 'QaSummaryResponse';
  month: Array<Maybe<QaUserSummary>>;
  week: Array<Maybe<QaUserSummary>>;
};

export type QaUserSummary = {
  __typename?: 'QaUserSummary';
  count: Scalars['Int']['output'];
  user: CommunityAuthor;
};

export type Query = {
  __typename?: 'Query';
  appVersion?: Maybe<AppVersion>;
  commerce?: Maybe<CommerceQueries>;
  community?: Maybe<CommunityQueries>;
  competition?: Maybe<CompetitionQueries>;
  countryConfigs?: Maybe<Array<Maybe<CountryConfig>>>;
  crafter?: Maybe<CrafterQueries>;
  customerContent: CustomerContentResponse;
  guestPattern?: Maybe<Pattern>;
  guestPatternBySku?: Maybe<Pattern>;
  loyalty?: Maybe<LoyaltyQueries>;
  moderation?: Maybe<ModerationQueries>;
  notification?: Maybe<NotificationQueries>;
  orderPatterns?: Maybe<Array<Maybe<Pattern>>>;
  pattern?: Maybe<Pattern>;
  patternBySku?: Maybe<Pattern>;
  productReviews?: Maybe<ProductReviewsQueries>;
  qa?: Maybe<QaQueries>;
  shopify?: Maybe<ShopifyQueries>;
  toc?: Maybe<TocQueries>;
  userContent?: Maybe<UserContentQueries>;
  users?: Maybe<UsersQueries>;
};


export type QueryCountryConfigsArgs = {
  countryConfigInput?: InputMaybe<CountryConfigInput>;
};


export type QueryCustomerContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGuestPatternArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryGuestPatternBySkuArgs = {
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
};


export type QueryOrderPatternsArgs = {
  checkout_token?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  shop?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatternArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatternBySkuArgs = {
  contactUUID?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  urlVersion?: InputMaybe<Scalars['String']['input']>;
};

export type RangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type Reaction = {
  __typename?: 'Reaction';
  author: CommunityAuthor;
  label: Scalars['String']['output'];
};

export type ReactionCounts = {
  __typename?: 'ReactionCounts';
  cool: Scalars['Int']['output'];
  haha: Scalars['Int']['output'];
  in_love: Scalars['Int']['output'];
  love: Scalars['Int']['output'];
  smile: Scalars['Int']['output'];
  wow: Scalars['Int']['output'];
};

export enum ReactionType {
  Cool = 'cool',
  Haha = 'haha',
  InLove = 'in_love',
  Love = 'love',
  Smile = 'smile',
  Wow = 'wow'
}

export type ReactionsResponse = {
  __typename?: 'ReactionsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  reactions?: Maybe<Array<Reaction>>;
};

export type ReadNotificationResponse = MutationResponse & {
  __typename?: 'ReadNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type ReadNotificationsInput = {
  notifications: Array<Scalars['ID']['input']>;
};

export type ReadNotificationsResponse = MutationResponse & {
  __typename?: 'ReadNotificationsResponse';
  success: Scalars['Boolean']['output'];
};

export type ReadUserNotificationsResponse = MutationResponse & {
  __typename?: 'ReadUserNotificationsResponse';
  success: Scalars['Boolean']['output'];
};

export type RejectReportInput = {
  id: Scalars['ID']['input'];
};

export type RejectReportResponse = MutationResponse & {
  __typename?: 'RejectReportResponse';
  success: Scalars['Boolean']['output'];
};

export type Report = {
  __typename?: 'Report';
  comment?: Maybe<Comment>;
  context?: Maybe<Context>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  offender: CommunityAuthor;
  post?: Maybe<Post>;
  processed_at?: Maybe<Scalars['String']['output']>;
  reason: ReportReason;
  reporter: CommunityAuthor;
};

export type ReportCommentInput = {
  comment_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportPostInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  post_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportProfileInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  profile_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportReason = {
  __typename?: 'ReportReason';
  reason: Scalars['String']['output'];
};

export type ReportResponse = MutationResponse & {
  __typename?: 'ReportResponse';
  success: Scalars['Boolean']['output'];
};

export type ReportsInput = {
  newest_first?: InputMaybe<Scalars['Boolean']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportsResponse = SimplePaginationResponse & {
  __typename?: 'ReportsResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  reports: Array<Report>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReviewAuthor = {
  __typename?: 'ReviewAuthor';
  avatar?: Maybe<Avatar>;
  avatar_url: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ReviewTranslation = {
  __typename?: 'ReviewTranslation';
  body_text: Scalars['String']['output'];
  language: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type RowCounter = {
  __typename?: 'RowCounter';
  count?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RowCountersResponse = {
  __typename?: 'RowCountersResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<RowCounter>>>;
  limit: Scalars['Int']['output'];
};

export type Sale = {
  __typename?: 'Sale';
  description: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  groups: Array<Maybe<SaleGroup>>;
  id: Scalars['Int']['output'];
  internal_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sale_banner_image_url?: Maybe<Scalars['String']['output']>;
  site_banner_image_url?: Maybe<Scalars['String']['output']>;
  spotlight_image_url?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['String']['output'];
};

export type SaleGroup = {
  __typename?: 'SaleGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products: Array<Maybe<SaleProduct>>;
};

export type SaleProduct = {
  __typename?: 'SaleProduct';
  discount_percentage: Scalars['Float']['output'];
  discounted_price: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  opencart_id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sanity_id: Scalars['String']['output'];
  shopify_id: Scalars['String']['output'];
};

export type SaleQueries = {
  __typename?: 'SaleQueries';
  saleProducts?: Maybe<Array<Maybe<SaleProduct>>>;
  sales?: Maybe<Array<Maybe<Sale>>>;
};


export type SaleQueriesSaleProductsArgs = {
  sale_id: Scalars['Int']['input'];
};


export type SaleQueriesSalesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetAvatarInput = {
  file_url: Scalars['String']['input'];
};

export type SetAvatarResponse = MutationResponse & {
  __typename?: 'SetAvatarResponse';
  avatar_url?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShopifyConfig = {
  __typename?: 'ShopifyConfig';
  currency?: Maybe<Scalars['String']['output']>;
  storeEndpoint?: Maybe<Scalars['String']['output']>;
  storefront?: Maybe<ShopifyStorefront>;
};

export type ShopifyCustomerAccessToken = {
  __typename?: 'ShopifyCustomerAccessToken';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
};

export type ShopifyCustomerUserErrors = {
  __typename?: 'ShopifyCustomerUserErrors';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ShopifyQueries = {
  __typename?: 'ShopifyQueries';
  exchangeToken?: Maybe<ExchangeTokenResponse>;
  multipassToken?: Maybe<MultipassTokenResponse>;
};


export type ShopifyQueriesExchangeTokenArgs = {
  store_name: Scalars['String']['input'];
};


export type ShopifyQueriesMultipassTokenArgs = {
  redirect_to?: InputMaybe<Scalars['String']['input']>;
  store_name: Scalars['String']['input'];
};

export type ShopifyStorefront = {
  __typename?: 'ShopifyStorefront';
  endpoint?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicAccessToken?: Maybe<Scalars['String']['output']>;
};

export type SimplePaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SimplePaginationResponse = {
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SourceType {
  Comment = 'comment',
  Reaction = 'reaction'
}

export type Store = {
  __typename?: 'Store';
  account: StoreAccountOptions;
  checkout_url: Scalars['String']['output'];
  contact_info: StoreContactInfo;
  country: Scalars['String']['output'];
  country_switcher_allowed: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  excludes_sales_taxes: Scalars['Boolean']['output'];
  google: StoreGoogleOptions;
  id: Scalars['Int']['output'];
  is_international: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  meta: StoreMeta;
  name: Scalars['String']['output'];
  payment: StorePaymentOptions;
  shipping: StoreShippingOptions;
  url: Scalars['String']['output'];
};

export type StoreAccountOptions = {
  __typename?: 'StoreAccountOptions';
  enabled: Scalars['Boolean']['output'];
  phone_number_required: Scalars['Boolean']['output'];
};

export type StoreContactInfo = {
  __typename?: 'StoreContactInfo';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type StoreGoogleOptions = {
  __typename?: 'StoreGoogleOptions';
  recaptcha_site_key?: Maybe<Scalars['String']['output']>;
  tag_manager_id?: Maybe<Scalars['String']['output']>;
};

export type StoreMeta = {
  __typename?: 'StoreMeta';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StorePaymentOptions = {
  __typename?: 'StorePaymentOptions';
  providers: Array<Maybe<Scalars['String']['output']>>;
};

export type StoreShippingOptions = {
  __typename?: 'StoreShippingOptions';
  delivery_time?: Maybe<Scalars['String']['output']>;
  free_shipping_threshold: Scalars['Int']['output'];
  min_shipping_price: Scalars['Float']['output'];
};

export type StoresQueries = {
  __typename?: 'StoresQueries';
  context?: Maybe<Store>;
  store?: Maybe<Store>;
  stores?: Maybe<Array<Maybe<Store>>>;
};


export type StoresQueriesContextArgs = {
  countryCode: Scalars['String']['input'];
};


export type StoresQueriesStoreArgs = {
  id: Scalars['Int']['input'];
};


export type StoresQueriesStoresArgs = {
  countryCode: Scalars['String']['input'];
};

export type SuccessResponse = MutationResponse & {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type SuggestedYarnResponse = {
  __typename?: 'SuggestedYarnResponse';
  other?: Maybe<YarnsResponse>;
  suggested?: Maybe<YarnsResponse>;
};

export type Survey = {
  __typename?: 'Survey';
  created_at: Scalars['String']['output'];
  help_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: Array<SurveyQuestion>;
  updated_at: Scalars['String']['output'];
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  created_at: Scalars['String']['output'];
  help_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options?: Maybe<Array<SurveyQuestionOption>>;
  order: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  type: SurveyQuestionType;
  updated_at: Scalars['String']['output'];
};

export type SurveyQuestionOption = {
  __typename?: 'SurveyQuestionOption';
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export enum SurveyQuestionType {
  Checkbox = 'checkbox',
  Radio = 'radio',
  Select = 'select',
  Text = 'text'
}

export type SurveyResponseCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** The ISO 639-1 language code for the locale of the survey. */
  locale?: InputMaybe<LanguageType>;
  subject: Scalars['String']['input'];
  subject_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SurveyResponseCreateResponse = {
  __typename?: 'SurveyResponseCreateResponse';
  id: Scalars['ID']['output'];
  survey: Survey;
};

export type SurveyResponseInput = {
  option_id?: InputMaybe<Scalars['ID']['input']>;
  question_id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyResponseSaveInput = {
  id: Scalars['ID']['input'];
  responses: Array<SurveyResponseInput>;
};

export type SurveyResponseSaveResponse = {
  __typename?: 'SurveyResponseSaveResponse';
  success: Scalars['Boolean']['output'];
};

export enum TargetType {
  Comment = 'comment',
  Post = 'post'
}

export type Teaser = {
  __typename?: 'Teaser';
  description?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  site_name?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Term = {
  __typename?: 'Term';
  content: Scalars['String']['output'];
  path: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type TermAcceptResponse = MutationResponse & {
  __typename?: 'TermAcceptResponse';
  success: Scalars['Boolean']['output'];
};

export type TermDeclineResponse = MutationResponse & {
  __typename?: 'TermDeclineResponse';
  success: Scalars['Boolean']['output'];
};

export type TermStatusResponse = MutationResponse & {
  __typename?: 'TermStatusResponse';
  success: Scalars['Boolean']['output'];
};

export type TocMutations = {
  __typename?: 'TocMutations';
  accept?: Maybe<TermAcceptResponse>;
  decline?: Maybe<TermDeclineResponse>;
};


export type TocMutationsAcceptArgs = {
  alias: Scalars['String']['input'];
};


export type TocMutationsDeclineArgs = {
  alias: Scalars['String']['input'];
};

export type TocQueries = {
  __typename?: 'TocQueries';
  show?: Maybe<Term>;
  status?: Maybe<TermStatusResponse>;
};


export type TocQueriesShowArgs = {
  alias: Scalars['String']['input'];
};


export type TocQueriesStatusArgs = {
  alias: Scalars['String']['input'];
};

export enum UnitSystem {
  Imperial = 'imperial',
  Metric = 'metric'
}

export type UnreadNotificationResponse = MutationResponse & {
  __typename?: 'UnreadNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type UnreadNotificationsInput = {
  notifications: Array<Scalars['ID']['input']>;
};

export type UnreadNotificationsResponse = MutationResponse & {
  __typename?: 'UnreadNotificationsResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateCommentInput = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdatePostInput = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileResponse = MutationResponse & {
  __typename?: 'UpdateProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateRowCounterInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadImageInput = {
  image_type: ImageType;
};

export type User = {
  __typename?: 'User';
  /** @deprecated Use `user` instead. */
  avatar: Avatar;
  /** @deprecated Use `user` instead. */
  avatar_url: Scalars['String']['output'];
  /** @deprecated Use `user` instead. */
  contact_uuid: Scalars['ID']['output'];
  /** @deprecated Use `user` instead. */
  country: UserCountry;
  /** @deprecated Use `user` instead. */
  created_at: Scalars['String']['output'];
  /** @deprecated Use `user` instead. */
  date_of_birth?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `user` instead. */
  email: Scalars['String']['output'];
  /** @deprecated Use `user` instead. */
  experience_level: UserExperienceLevel;
  /** @deprecated Use `user` instead. */
  first_name: Scalars['String']['output'];
  /** @deprecated Use `user` instead. */
  id: Scalars['Int']['output'];
  /** @deprecated Use `user` instead. */
  last_name: Scalars['String']['output'];
  /** @deprecated Use `user` instead. */
  location_id: Scalars['Int']['output'];
  /** @deprecated Use `user` instead. */
  odoo_partner_id: Scalars['Int']['output'];
  /** @deprecated Use `user` instead. */
  phone: Scalars['String']['output'];
  /** @deprecated Use `user` instead. */
  points_total: Scalars['Int']['output'];
  /** @deprecated Use `user` instead. */
  store_id: Scalars['Int']['output'];
  /** @deprecated Use `user` instead. */
  uuid: Scalars['ID']['output'];
};

export type UserContentMutations = {
  __typename?: 'UserContentMutations';
  createRowCounter: RowCounter;
  deleteRowCounter: DeleteRowCounterResponse;
  updateRowCounter: RowCounter;
};


export type UserContentMutationsCreateRowCounterArgs = {
  input: CreateRowCounterInput;
};


export type UserContentMutationsDeleteRowCounterArgs = {
  id: Scalars['ID']['input'];
};


export type UserContentMutationsUpdateRowCounterArgs = {
  input: UpdateRowCounterInput;
};

export type UserContentQueries = {
  __typename?: 'UserContentQueries';
  rowCounter?: Maybe<RowCounter>;
  rowCounters?: Maybe<RowCountersResponse>;
};


export type UserContentQueriesRowCounterArgs = {
  id: Scalars['ID']['input'];
};


export type UserContentQueriesRowCountersArgs = {
  context?: InputMaybe<ContextInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCountry = {
  __typename?: 'UserCountry';
  id: Scalars['Int']['output'];
  iso_code_2: Scalars['String']['output'];
  iso_code_3: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserExperienceLevel = {
  __typename?: 'UserExperienceLevel';
  crochet?: Maybe<UserExperienceLevelEnum>;
  knit?: Maybe<UserExperienceLevelEnum>;
};

export enum UserExperienceLevelEnum {
  Advanced = 'advanced',
  Expert = 'expert',
  Intermediate = 'intermediate',
  Novice = 'novice',
  Unknown = 'unknown'
}

export type UserLoyaltyPointsRecordResponse = {
  __typename?: 'UserLoyaltyPointsRecordResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  entries: Array<Point>;
  limit: Scalars['Int']['output'];
};

export type UserPattern = {
  __typename?: 'UserPattern';
  craft_type?: Maybe<CraftType>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ProductImage>;
  name: Scalars['String']['output'];
  projects?: Maybe<Array<Project>>;
  updated_at: Scalars['String']['output'];
};

export type UserPatternMatchDetailsResponse = {
  __typename?: 'UserPatternMatchDetailsResponse';
  exact_matches?: Maybe<Array<Maybe<Yarn>>>;
  family_matches?: Maybe<Array<Maybe<Yarn>>>;
  match: YarnMatch;
  pattern: HobbiiPattern;
};

export type UserV2 = {
  __typename?: 'UserV2';
  avatar: Avatar;
  contact_uuid: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  loyalty: LoyaltyUser;
  phone: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type UsernameCheckResponse = {
  __typename?: 'UsernameCheckResponse';
  available: Scalars['Boolean']['output'];
};

export type UsersMutations = {
  __typename?: 'UsersMutations';
  createImageUploadOptions: ImageUploadOptions;
  deleteAvatar: DeleteAvatarResponse;
  deleteUser: DeleteUserResult;
  setAvatar: SetAvatarResponse;
  updateProfile?: Maybe<UpdateProfileResponse>;
};


export type UsersMutationsCreateImageUploadOptionsArgs = {
  input: UploadImageInput;
};


export type UsersMutationsDeleteAvatarArgs = {
  uuid: Scalars['String']['input'];
};


export type UsersMutationsSetAvatarArgs = {
  input: SetAvatarInput;
};


export type UsersMutationsUpdateProfileArgs = {
  input: UpdateProfileInput;
};

export type UsersQueries = {
  __typename?: 'UsersQueries';
  /** @deprecated Use `user` instead. */
  current?: Maybe<User>;
  getAvatar: GetAvatarResponse;
  user: UserV2;
  usernameCheck?: Maybe<UsernameCheckResponse>;
};


export type UsersQueriesGetAvatarArgs = {
  uuid: Scalars['String']['input'];
};


export type UsersQueriesUsernameCheckArgs = {
  username: Scalars['String']['input'];
};

/**
 * Represents a wishlist category that can contain multiple wishlist items.
 * Users can have multiple wishlists to organize their saved products.
 */
export type Wishlist = {
  __typename?: 'Wishlist';
  created_at: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if this is the user's default wishlist. The default wishlist cannot be deleted. */
  is_default: Scalars['Boolean']['output'];
  /** Indicates if the wishlist is public or private. */
  is_public: Scalars['Boolean']['output'];
  /** Paginated items in this wishlist. Use cursor and limit parameters for pagination. */
  items?: Maybe<WishlistItemsResponse>;
  name: Scalars['String']['output'];
  public_id: Scalars['ID']['output'];
  updated_at: Scalars['String']['output'];
};


/**
 * Represents a wishlist category that can contain multiple wishlist items.
 * Users can have multiple wishlists to organize their saved products.
 */
export type WishlistItemsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Response type for adding an item to a wishlist */
export type WishlistAddItemResponse = {
  __typename?: 'WishlistAddItemResponse';
  /** Contains validation or error messages if the operation failed */
  userErrors?: Maybe<Array<Scalars['String']['output']>>;
  wishlistItem?: Maybe<WishlistItem>;
};

/** Input for creating a new wishlist */
export type WishlistCreateInput = {
  /** Optional description for the wishlist */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the wishlist (required) */
  name: Scalars['String']['input'];
  /** Optional flag to set the wishlist as public (default is false) */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response type for wishlist creation */
export type WishlistCreateResponse = {
  __typename?: 'WishlistCreateResponse';
  /** Contains validation or error messages if the operation failed */
  userErrors?: Maybe<Array<Scalars['String']['output']>>;
  wishlist?: Maybe<Wishlist>;
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product_group_identifier?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** Paginated response for wishlist items query */
export type WishlistItemsResponse = {
  __typename?: 'WishlistItemsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<WishlistItem>;
  limit?: Maybe<Scalars['Int']['output']>;
};

/** Response type for removing an item from a wishlist */
export type WishlistRemoveItemResponse = {
  __typename?: 'WishlistRemoveItemResponse';
  success: Scalars['Boolean']['output'];
  /** Contains validation or error messages if the operation failed */
  userErrors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Response type for reordering items in a wishlist */
export type WishlistReorderItemsResponse = {
  __typename?: 'WishlistReorderItemsResponse';
  success: Scalars['Boolean']['output'];
  /** Contains validation or error messages if the operation failed */
  userErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type WishlistResponse = {
  __typename?: 'WishlistResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  wishlist?: Maybe<Array<WishlistItem>>;
};

/** Sorting options for wishlists query */
export enum WishlistSortBy {
  /** Sort wishlists by creation date */
  CreatedAt = 'created_at',
  /** Sort wishlists alphabetically by name */
  Name = 'name',
  /** Sort wishlists by last update date */
  UpdatedAt = 'updated_at'
}

/**
 * Input for updating an existing wishlist.
 * At least one field must be provided.
 */
export type WishlistUpdateInput = {
  /** New description for the wishlist (optional) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New name for the wishlist (optional) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional flag to set the wishlist as public or private */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response type for wishlist update */
export type WishlistUpdateResponse = {
  __typename?: 'WishlistUpdateResponse';
  /** Contains validation or error messages if the operation failed */
  userErrors?: Maybe<Array<Scalars['String']['output']>>;
  wishlist?: Maybe<Wishlist>;
};

/** Paginated response for wishlists query */
export type WishlistsResponse = {
  __typename?: 'WishlistsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  wishlists: Array<Wishlist>;
};

export type Yarn = {
  __typename?: 'Yarn';
  brand?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  crochet_gauge?: Maybe<Gauge>;
  id: Scalars['ID']['output'];
  image?: Maybe<ProductImage>;
  in_use?: Maybe<Scalars['Int']['output']>;
  knitting_gauge?: Maybe<Gauge>;
  location?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `brand` instead. */
  manufacturer?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Project>>;
  quantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
  yarn_weight?: Maybe<Scalars['String']['output']>;
};

export type YarnContentInput = {
  fiber: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Int']['input']>;
};

export type YarnCreateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  content?: InputMaybe<Array<YarnContentInput>>;
  crochet_gauge?: InputMaybe<GaugeInput>;
  image_file_identifier?: InputMaybe<Scalars['String']['input']>;
  knitting_gauge?: InputMaybe<GaugeInput>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  yarn_weight?: InputMaybe<Scalars['String']['input']>;
};

export type YarnDeleteResponse = {
  __typename?: 'YarnDeleteResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type YarnFilter = FilterItems | FilterRange;

export type YarnFilterInput = {
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  color?: InputMaybe<Array<Scalars['String']['input']>>;
  crochet_gauge?: InputMaybe<RangeInput>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  knitting_gauge?: InputMaybe<RangeInput>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  project?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<RangeInput>;
  yarn_weight?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type YarnMatch = {
  __typename?: 'YarnMatch';
  exact_matches: Scalars['Int']['output'];
  family_matches: Scalars['Int']['output'];
  label: MatchLabel;
  missing_yarns: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  total_yarns: Scalars['Int']['output'];
};

export enum YarnSortBy {
  Brand = 'brand',
  CreatedAt = 'created_at',
  /** @deprecated Use `brand` instead. */
  Manufacturer = 'manufacturer',
  Name = 'name',
  Quantity = 'quantity',
  UpdatedAt = 'updated_at'
}

export type YarnUpdateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Array<YarnContentInput>>;
  crochet_gauge?: InputMaybe<GaugeInput>;
  id: Scalars['ID']['input'];
  image_file_identifier?: InputMaybe<Scalars['String']['input']>;
  knitting_gauge?: InputMaybe<GaugeInput>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  yarn_weight?: InputMaybe<Scalars['String']['input']>;
};

export type YarnsResponse = {
  __typename?: 'YarnsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<YarnFilter>>;
  limit?: Maybe<Scalars['Int']['output']>;
  yarns?: Maybe<Array<Yarn>>;
};

export type CreateReviewMutationMutationVariables = Exact<{
  input: CreateProductReviewInput;
}>;


export type CreateReviewMutationMutation = { __typename?: 'Mutation', productReviews?: { __typename?: 'ProductReviewsMutations', createReview: { __typename?: 'ProductReview', id: string } } | null };

export type ProductReviewsQueryVariables = Exact<{
  input: ListProductReviewInput;
}>;


export type ProductReviewsQuery = { __typename?: 'Query', productReviews?: { __typename?: 'ProductReviewsQueries', listReviews: { __typename?: 'ProductReviewsResponse', cursor?: string | null, reviews: Array<{ __typename?: 'ProductReview', rating: number, id: string, created_at: string, published_at: string, translated?: { __typename?: 'ReviewTranslation', title: string, body_text: string, language: string } | null, original: { __typename?: 'ReviewTranslation', title: string, body_text: string, language: string }, author: { __typename?: 'ReviewAuthor', avatar_url: string, display_name: string, name: string, username: string } }> } } | null };

export type PatternSuggestionsForYarnQueryVariables = Exact<{
  yarnProductGroupIdentifier: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatternSuggestionsForYarnQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', patternSuggestionsForYarn?: { __typename?: 'HobbiiPatternsResponse', cursor?: string | null, limit?: number | null, patterns?: Array<{ __typename?: 'HobbiiPattern', name: string, sku: string, image?: { __typename?: 'ProductImage', url: string, alt: string } | null }> | null } | null } | null };

export type CreatePostMutationVariables = Exact<{
  context?: InputMaybe<ContextInput>;
  input?: InputMaybe<CreatePostInput>;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', createPost?: { __typename?: 'Post', id: string, body: string, images?: Array<string> | null, published_at: string, comments_count: number, own_reaction?: ReactionType | null, author: { __typename?: 'CommunityAuthor', id: string, name: string, username: string, display_name: string, avatar_url: string, is_blocking: boolean, is_following: boolean }, reaction_counts: { __typename?: 'ReactionCounts', love: number, in_love: number, smile: number, cool: number, haha: number, wow: number }, context?: { __typename?: 'Context', kind?: KindType | null, entity?: EntityType | null, entity_id?: string | null, language?: LanguageType | null } | null, teaser?: { __typename?: 'Teaser', site_name?: string | null, url?: string | null, title?: string | null, type?: string | null } | null } | null } | null };

export type UpdatePostMutationVariables = Exact<{
  input?: InputMaybe<UpdatePostInput>;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', updatePost?: { __typename?: 'Post', id: string, body: string, images?: Array<string> | null } | null } | null };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', deletePost?: { __typename?: 'DeletePostResponse', success: boolean } | null } | null };

export type CreateCommunityImageUploadOptionsMutationVariables = Exact<{
  input?: InputMaybe<UploadImageInput>;
}>;


export type CreateCommunityImageUploadOptionsMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', createImageUploadOptions?: { __typename?: 'ImageUploadOptions', upload_endpoint: string, file_url: string } | null } | null };

export type CreateProfileImageUploadOptionsMutationVariables = Exact<{
  input: UploadImageInput;
}>;


export type CreateProfileImageUploadOptionsMutation = { __typename?: 'Mutation', users?: { __typename?: 'UsersMutations', createImageUploadOptions: { __typename?: 'ImageUploadOptions', upload_endpoint: string, file_url: string } } | null };

export type SetProfileAvatarMutationVariables = Exact<{
  input: SetAvatarInput;
}>;


export type SetProfileAvatarMutation = { __typename?: 'Mutation', users?: { __typename?: 'UsersMutations', setAvatar: { __typename?: 'SetAvatarResponse', avatar_url?: string | null, success: boolean } } | null };

export type DeleteProfileAvatarMutationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteProfileAvatarMutationMutation = { __typename?: 'Mutation', users?: { __typename?: 'UsersMutations', deleteAvatar: { __typename?: 'DeleteAvatarResponse', success: boolean } } | null };

export type CreateCommentMutationVariables = Exact<{
  input?: InputMaybe<CreateCommentInput>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', createComment?: { __typename?: 'Comment', id: string, body: string, images?: Array<string> | null, own_reaction?: ReactionType | null, published_at: string, post_id: string, author: { __typename?: 'CommunityAuthor', id: string, name: string, username: string, display_name: string, avatar_url: string, is_blocking: boolean, is_following: boolean }, reaction_counts: { __typename?: 'ReactionCounts', love: number, in_love: number, smile: number, cool: number, haha: number, wow: number } } | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  input?: InputMaybe<UpdateCommentInput>;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', updateComment?: { __typename?: 'Comment', id: string, body: string, images?: Array<string> | null } | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', deleteComment?: { __typename?: 'DeleteCommentResponse', success: boolean } | null } | null };

export type CreateReactionMutationVariables = Exact<{
  input?: InputMaybe<CreateReactionInput>;
}>;


export type CreateReactionMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', createReaction?: { __typename?: 'CreateReactionResponse', success: boolean } | null } | null };

export type DeleteReactionMutationVariables = Exact<{
  input?: InputMaybe<DeleteReactionInput>;
}>;


export type DeleteReactionMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', deleteReaction?: { __typename?: 'DeleteReactionResponse', success: boolean } | null } | null };

export type FollowMutationVariables = Exact<{
  input?: InputMaybe<FollowInput>;
}>;


export type FollowMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', follow?: { __typename?: 'FollowResponse', success: boolean } | null } | null };

export type UnfollowMutationVariables = Exact<{
  input?: InputMaybe<FollowInput>;
}>;


export type UnfollowMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', unfollow?: { __typename?: 'FollowResponse', success: boolean } | null } | null };

export type ReportPostMutationVariables = Exact<{
  input?: InputMaybe<ReportPostInput>;
}>;


export type ReportPostMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', reportPost?: { __typename?: 'ReportResponse', success: boolean } | null } | null };

export type ReportCommentMutationVariables = Exact<{
  input?: InputMaybe<ReportCommentInput>;
}>;


export type ReportCommentMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', reportComment?: { __typename?: 'ReportResponse', success: boolean } | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', users?: { __typename?: 'UsersMutations', updateProfile?: { __typename?: 'UpdateProfileResponse', success: boolean } | null } | null };

export type AcceptTosMutationVariables = Exact<{
  alias: Scalars['String']['input'];
}>;


export type AcceptTosMutation = { __typename?: 'Mutation', toc?: { __typename?: 'TocMutations', accept?: { __typename?: 'TermAcceptResponse', success: boolean } | null } | null };

export type BlockUserMutationVariables = Exact<{
  input?: InputMaybe<BlockInput>;
}>;


export type BlockUserMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', block?: { __typename?: 'BlockResponse', success: boolean } | null } | null };

export type UnblockUserMutationVariables = Exact<{
  input?: InputMaybe<BlockInput>;
}>;


export type UnblockUserMutation = { __typename?: 'Mutation', community?: { __typename?: 'CommunityMutations', unblock?: { __typename?: 'BlockResponse', success: boolean } | null } | null };

export type PostQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type PostQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', post?: { __typename?: 'Post', id: string, body: string, images?: Array<string> | null, published_at: string, comments_count: number, own_reaction?: ReactionType | null, author: { __typename?: 'CommunityAuthor', id: string, name: string, username: string, display_name: string, avatar_url: string, is_blocking: boolean, is_following: boolean }, reaction_counts: { __typename?: 'ReactionCounts', love: number, in_love: number, smile: number, cool: number, haha: number, wow: number }, context?: { __typename?: 'Context', kind?: KindType | null, entity?: EntityType | null, entity_id?: string | null, language?: LanguageType | null } | null, teaser?: { __typename?: 'Teaser', site_name?: string | null, url?: string | null, title?: string | null, type?: string | null } | null } | null } | null };

export type PostsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  context?: InputMaybe<ContextInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostsQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', posts?: { __typename?: 'PostsResponse', cursor?: string | null, limit: number, total?: number | null, posts: Array<{ __typename?: 'Post', id: string, body: string, images?: Array<string> | null, published_at: string, comments_count: number, own_reaction?: ReactionType | null, author: { __typename?: 'CommunityAuthor', id: string, name: string, username: string, display_name: string, avatar_url: string, is_blocking: boolean, is_following: boolean }, reaction_counts: { __typename?: 'ReactionCounts', love: number, in_love: number, smile: number, cool: number, haha: number, wow: number }, context?: { __typename?: 'Context', kind?: KindType | null, entity?: EntityType | null, entity_id?: string | null, language?: LanguageType | null } | null, teaser?: { __typename?: 'Teaser', site_name?: string | null, url?: string | null, title?: string | null, type?: string | null } | null }> } | null } | null };

export type CommentsQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentsQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', comments?: { __typename?: 'CommentsResponse', cursor?: string | null, limit: number, comments: Array<{ __typename?: 'Comment', post_id: string, body: string, id: string, images?: Array<string> | null, own_reaction?: ReactionType | null, published_at: string, author: { __typename?: 'CommunityAuthor', id: string, name: string, display_name: string, username: string, avatar_url: string, is_blocking: boolean, is_following: boolean }, reaction_counts: { __typename?: 'ReactionCounts', love: number, in_love: number, smile: number, cool: number, haha: number, wow: number } }> } | null } | null };

export type ReactionsQueryVariables = Exact<{
  input: GetReactionsInput;
}>;


export type ReactionsQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', reactions?: { __typename?: 'ReactionsResponse', cursor?: string | null, limit?: number | null, reactions?: Array<{ __typename?: 'Reaction', label: string, author: { __typename?: 'CommunityAuthor', id: string, name: string, username: string, display_name: string, avatar_url: string, is_blocking: boolean, is_following: boolean } }> | null } | null } | null };

export type ProfileQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ProfileQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', profile?: { __typename?: 'Profile', id: string, followers_count: number, following_count: number, user: { __typename?: 'CommunityAuthor', id: string, avatar_url: string, display_name: string, name: string, username: string, is_blocking: boolean, is_following: boolean, country?: string | null, bio?: string | null } } | null } | null };

export type ProfileNameCheckQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfileNameCheckQuery = { __typename?: 'Query', users?: { __typename?: 'UsersQueries', usernameCheck?: { __typename?: 'UsernameCheckResponse', available: boolean } | null } | null };

export type LimitedNoteFragment = { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string };

export type FullNoteFragment = { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProjectImage', id: string, url: string }> | null };

export type ListProjectFragment = { __typename?: 'Project', id: string, short_id: string, name: string, craft_type?: CraftType | null, is_public: boolean, state: ProjectState, created_at: string, ends_at?: string | null, started_at?: string | null, updated_at: string, image?: { __typename?: 'ProjectImage', id: string, url: string } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string } | null, pattern?: { __typename?: 'UserPattern', id: string, name: string } | null };

export type SingleProjectFragment = { __typename?: 'Project', id: string, short_id: string, is_public: boolean, name: string, state: ProjectState, craft_type?: CraftType | null, started_at?: string | null, recipient?: string | null, ends_at?: string | null, created_at: string, updated_at: string, image?: { __typename?: 'ProjectImage', id: string, url: string } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string } | null, projectActivities?: { __typename?: 'ProjectActivitiesResponse', limit?: number | null, cursor?: string | null, activities: Array<{ __typename?: 'ProjectActivity', type: ActivityType, created_at: string, updated_at: string, details?: { __typename?: 'ProjectStateChangeDetails', from: ProjectState, to: ProjectState } | { __typename?: 'ProjectVisibilityChangeDetails', is_public: boolean, published_at?: string | null } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProjectImage', id: string, url: string }> | null } | null }> } | null, projectNotes?: { __typename?: 'ProjectNotesResponse', limit?: number | null, cursor?: string | null, notes: Array<{ __typename?: 'ProjectNote', id: string, content: string, rows?: number | null, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProjectImage', id: string, url: string }> | null }> } | null, pattern?: { __typename?: 'UserPattern', id: string, name: string, craft_type?: CraftType | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null } | null, yarns?: Array<{ __typename?: 'Yarn', id: string, name: string, in_use?: number | null, quantity: number }> | null };

export type FullYarnFragment = { __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null };

export type ProjectQuantityYarnFragment = { __typename?: 'Yarn', id: string, name: string, in_use?: number | null, quantity: number };

export type ReadNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', readNotification?: { __typename?: 'ReadNotificationResponse', success: boolean } | null } | null };

export type ReadNotificationsMutationVariables = Exact<{
  input?: InputMaybe<ReadNotificationsInput>;
}>;


export type ReadNotificationsMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', readNotifications?: { __typename?: 'ReadNotificationsResponse', success: boolean } | null } | null };

export type SeenUserNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type SeenUserNotificationsMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', seenUserNotifications: { __typename?: 'SuccessResponse', success: boolean } } | null };

export type CrafterProjectCreateMutationVariables = Exact<{
  input: ProjectCreateInput;
}>;


export type CrafterProjectCreateMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userProjectCreate?: { __typename?: 'Project', id: string, short_id: string, name: string, craft_type?: CraftType | null, is_public: boolean, state: ProjectState, created_at: string, ends_at?: string | null, started_at?: string | null, updated_at: string, image?: { __typename?: 'ProjectImage', id: string, url: string } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string } | null, pattern?: { __typename?: 'UserPattern', id: string, name: string } | null } | null } | null };

export type CrafterProjectFileUploadMutationVariables = Exact<{
  input: FileUploadCreateInput;
}>;


export type CrafterProjectFileUploadMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', fileUploadCreate?: { __typename?: 'FileUpload', file_identifier: string, upload_endpoint: string } | null } | null };

export type CrafterProjectUpdateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  input?: InputMaybe<ProjectUpdateInput>;
}>;


export type CrafterProjectUpdateMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userProjectUpdate?: { __typename?: 'Project', id: string, name: string, craft_type?: CraftType | null, is_public: boolean, state: ProjectState, recipient?: string | null, started_at?: string | null, ends_at?: string | null, image?: { __typename?: 'ProjectImage', id: string, url: string } | null } | null } | null };

export type CrafterProjectProgressUpdateMutationVariables = Exact<{
  input: ProjectProgressUpdateInput;
}>;


export type CrafterProjectProgressUpdateMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userProjectUpdateProgress?: { __typename?: 'ProjectNote', id: string, content: string, rows?: number | null, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProjectImage', id: string, url: string }> | null } | null } | null };

export type UserProjectAssignYarnMutationVariables = Exact<{
  input: ProjectAssignYarnInput;
}>;


export type UserProjectAssignYarnMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userProjectAssignYarn?: { __typename?: 'Project', id: string, updated_at: string, yarns?: Array<{ __typename?: 'Yarn', id: string, quantity: number, in_use?: number | null, updated_at: string }> | null } | null } | null };

export type CrafterCreateSurveyMutationVariables = Exact<{
  input: SurveyResponseCreateInput;
}>;


export type CrafterCreateSurveyMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', surveyResponseCreate?: { __typename?: 'SurveyResponseCreateResponse', id: string, survey: { __typename?: 'Survey', id: string, name: string, help_text?: string | null, questions: Array<{ __typename?: 'SurveyQuestion', id: string, text: string, help_text?: string | null, required: boolean, type: SurveyQuestionType, order: number, options?: Array<{ __typename?: 'SurveyQuestionOption', id: string, text: string, order: number }> | null }> } } | null } | null };

export type CrafterSaveSurveyMutationVariables = Exact<{
  input: SurveyResponseSaveInput;
}>;


export type CrafterSaveSurveyMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', surveyResponseSave?: { __typename?: 'SurveyResponseSaveResponse', success: boolean } | null } | null };

export type UserYarnCreateMutationVariables = Exact<{
  input: YarnCreateInput;
}>;


export type UserYarnCreateMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userYarnCreate?: { __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null } | null } | null };

export type UserYarnUpdateMutationVariables = Exact<{
  input: YarnUpdateInput;
}>;


export type UserYarnUpdateMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userYarnUpdate?: { __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null } | null } | null };

export type UserYarnDeleteMutationVariables = Exact<{
  userYarnDeleteId: Scalars['ID']['input'];
}>;


export type UserYarnDeleteMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', userYarnDelete?: { __typename?: 'YarnDeleteResponse', success: boolean, message?: string | null } | null } | null };

export type AddToWishlistMutationVariables = Exact<{
  sku?: InputMaybe<Scalars['String']['input']>;
  productGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddToWishlistMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', wishlistAddProduct?: { __typename?: 'WishlistItem', created_at: string, id: string, product_group_identifier?: string | null, sku?: string | null } | null } | null };

export type RemoveFromWishlistMutationVariables = Exact<{
  wishlistRemoveProductId: Scalars['ID']['input'];
}>;


export type RemoveFromWishlistMutation = { __typename?: 'Mutation', crafter?: { __typename?: 'CrafterMutations', wishlistRemoveProduct?: { __typename?: 'SuccessResponse', success: boolean } | null } | null };

export type CustomerAccessTokenQueryVariables = Exact<{
  storeName: Scalars['String']['input'];
}>;


export type CustomerAccessTokenQuery = { __typename?: 'Query', shopify?: { __typename?: 'ShopifyQueries', exchangeToken?: { __typename?: 'ExchangeTokenResponse', customerAccessToken?: { __typename?: 'ShopifyCustomerAccessToken', accessToken?: string | null, expiresAt?: string | null } | null } | null } | null };

export type StarterDataQueryVariables = Exact<{
  input: GetNotificationsInput;
  alias: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type StarterDataQuery = { __typename?: 'Query', notification?: { __typename?: 'NotificationQueries', notifications: { __typename?: 'NotificationsResponse', unread: number, unseen: number } } | null, toc?: { __typename?: 'TocQueries', status?: { __typename?: 'TermStatusResponse', success: boolean } | null } | null, community?: { __typename?: 'CommunityQueries', profile?: { __typename?: 'Profile', followers_count: number, following_count: number, user: { __typename?: 'CommunityAuthor', id: string, bio?: string | null, username: string, display_name: string, country?: string | null, avatar_url: string } } | null } | null };

export type NotificationsQueryVariables = Exact<{
  input: GetNotificationsInput;
}>;


export type NotificationsQuery = { __typename?: 'Query', notification?: { __typename?: 'NotificationQueries', notifications: { __typename?: 'NotificationsResponse', unread: number, unseen: number, total: number, cursor?: string | null, notifications: Array<{ __typename?: 'Notification', id: string, message: string, read_at?: string | null, created_at: string, sourceable_type: SourceType, sourceable_id: string, actor: { __typename?: 'CommunityAuthor', display_name: string, avatar_url: string }, subject: { __typename?: 'Comment', id: string, post_id: string } | { __typename?: 'Post', id: string } }> } } | null };

export type CountryConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryConfigsQuery = { __typename?: 'Query', countryConfigs?: Array<{ __typename?: 'CountryConfig', countryCode?: string | null, shopifyConfig?: { __typename?: 'ShopifyConfig', storeEndpoint?: string | null, storefront?: { __typename?: 'ShopifyStorefront', endpoint?: string | null, name?: string | null, publicAccessToken?: string | null } | null } | null } | null> | null };

export type CustomerContentQueryVariables = Exact<{
  language: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerContentQuery = { __typename?: 'Query', customerContent: { __typename?: 'CustomerContentResponse', cursor?: string | null, content: Array<{ __typename?: 'Pattern', id: string, sku: string, url: string, createdAt?: string | null, updatedAt?: string | null } | null> } };

export type PostCountersQueryVariables = Exact<{
  galleryContext?: InputMaybe<ContextInput>;
  qaContext?: InputMaybe<ContextInput>;
}>;


export type PostCountersQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', gallery?: { __typename?: 'PostsResponse', total?: number | null } | null, qa?: { __typename?: 'PostsResponse', total?: number | null } | null } | null };

export type LoyaltyQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyQuery = { __typename?: 'Query', loyalty?: { __typename?: 'LoyaltyQueries', points?: { __typename?: 'PointsResponse', cursor?: string | null, limit: number, points: Array<{ __typename?: 'Point', amount: number, created_at: string, type: string, description: string }> } | null } | null };

export type PatternBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  urlVersion?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  contactUUID?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PatternBySkuQuery = { __typename?: 'Query', patternBySku?: { __typename?: 'Pattern', url: string, sku: string, id: string, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetCountriesDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesDataQueryQuery = { __typename?: 'Query', countryConfigs?: Array<{ __typename?: 'CountryConfig', countryCode?: string | null, shopifyConfig?: { __typename?: 'ShopifyConfig', storeEndpoint?: string | null } | null, legacyStore?: { __typename?: 'Store', id: number, name: string, country: string, country_switcher_allowed: boolean, is_international: boolean, language: string, url: string, currency?: string | null } | null } | null> | null };

export type BingoIdQueryVariables = Exact<{
  countryConfigInput?: InputMaybe<CountryConfigInput>;
}>;


export type BingoIdQuery = { __typename?: 'Query', countryConfigs?: Array<{ __typename?: 'CountryConfig', bingoId?: string | null } | null> | null };

export type CrafterProjectsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<ProjectState> | ProjectState>;
}>;


export type CrafterProjectsQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userProjects?: { __typename?: 'ProjectsResponse', limit?: number | null, cursor?: string | null, projects: Array<{ __typename?: 'Project', id: string, short_id: string, name: string, craft_type?: CraftType | null, is_public: boolean, state: ProjectState, created_at: string, ends_at?: string | null, started_at?: string | null, updated_at: string, image?: { __typename?: 'ProjectImage', id: string, url: string } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string } | null, pattern?: { __typename?: 'UserPattern', id: string, name: string } | null }> } | null } | null };

export type CrafterProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  activitiesSortOrder?: InputMaybe<SortOrder>;
  activitiesLimit?: InputMaybe<Scalars['Int']['input']>;
  activitiesCursor?: InputMaybe<Scalars['String']['input']>;
  notesLimit?: InputMaybe<Scalars['Int']['input']>;
  notesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrafterProjectQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userProject?: { __typename?: 'Project', id: string, short_id: string, is_public: boolean, name: string, state: ProjectState, craft_type?: CraftType | null, started_at?: string | null, recipient?: string | null, ends_at?: string | null, created_at: string, updated_at: string, image?: { __typename?: 'ProjectImage', id: string, url: string } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string } | null, projectActivities?: { __typename?: 'ProjectActivitiesResponse', limit?: number | null, cursor?: string | null, activities: Array<{ __typename?: 'ProjectActivity', type: ActivityType, created_at: string, updated_at: string, details?: { __typename?: 'ProjectStateChangeDetails', from: ProjectState, to: ProjectState } | { __typename?: 'ProjectVisibilityChangeDetails', is_public: boolean, published_at?: string | null } | null, note?: { __typename?: 'ProjectNote', id: string, rows?: number | null, content: string, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProjectImage', id: string, url: string }> | null } | null }> } | null, projectNotes?: { __typename?: 'ProjectNotesResponse', limit?: number | null, cursor?: string | null, notes: Array<{ __typename?: 'ProjectNote', id: string, content: string, rows?: number | null, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProjectImage', id: string, url: string }> | null }> } | null, pattern?: { __typename?: 'UserPattern', id: string, name: string, craft_type?: CraftType | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null } | null, yarns?: Array<{ __typename?: 'Yarn', id: string, name: string, in_use?: number | null, quantity: number }> | null } | null } | null };

export type CrafterYarnQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CrafterYarnQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userYarn?: { __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null } | null } | null };

export type CrafterYarnsQueryVariables = Exact<{
  filters?: InputMaybe<YarnFilterInput>;
  sortBy?: InputMaybe<YarnSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CrafterYarnsQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userYarns?: { __typename?: 'YarnsResponse', cursor?: string | null, limit?: number | null, filters?: Array<{ __typename?: 'FilterItems', label: string, type: string, items?: Array<{ __typename?: 'FilterItem', label: string, results: number }> | null } | { __typename?: 'FilterRange', label: string, max: number, min: number, type: string }> | null, yarns?: Array<{ __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null }> | null } | null } | null };

export type CrafterYarnSuggestionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<YarnSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  suggestedCursor?: InputMaybe<Scalars['String']['input']>;
  otherCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrafterYarnSuggestionsQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userYarnSuggestions?: { __typename?: 'SuggestedYarnResponse', suggested?: { __typename?: 'YarnsResponse', limit?: number | null, cursor?: string | null, filters?: Array<{ __typename?: 'FilterItems', label: string, type: string, items?: Array<{ __typename?: 'FilterItem', label: string, results: number }> | null } | { __typename?: 'FilterRange', label: string, type: string, min: number, max: number }> | null, yarns?: Array<{ __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null }> | null } | null, other?: { __typename?: 'YarnsResponse', limit?: number | null, cursor?: string | null, filters?: Array<{ __typename?: 'FilterItems', label: string, type: string, items?: Array<{ __typename?: 'FilterItem', label: string, results: number }> | null } | { __typename?: 'FilterRange', label: string, type: string, min: number, max: number }> | null, yarns?: Array<{ __typename?: 'Yarn', id: string, name: string, color?: string | null, content?: string | null, note?: string | null, location?: string | null, brand?: string | null, sku?: string | null, weight?: number | null, yarn_weight?: string | null, quantity: number, created_at: string, updated_at: string, crochet_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, knitting_gauge?: { __typename?: 'Gauge', rows?: number | null, stitches?: number | null, unit: UnitSystem } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, in_use?: number | null }> | null }> | null } | null } | null } | null };

export type CrafterPatternsQueryVariables = Exact<{
  filters?: InputMaybe<PatternFilterInput>;
  sortBy?: InputMaybe<PatternSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CrafterPatternsQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userPatterns?: { __typename?: 'PatternsResponse', cursor?: string | null, limit?: number | null, filters?: Array<{ __typename?: 'FilterItems', label: string, type: string, items?: Array<{ __typename?: 'FilterItem', label: string, results: number }> | null } | { __typename?: 'FilterRange' }> | null, patterns?: Array<{ __typename?: 'UserPattern', id: string, name: string, craft_type?: CraftType | null, created_at: string, updated_at: string, image?: { __typename?: 'ProductImage', url: string, alt: string } | null, projects?: Array<{ __typename?: 'Project', id: string, name: string, state: ProjectState }> | null }> | null } | null } | null };

export type PublicCrafterProjectQueryVariables = Exact<{
  shortId: Scalars['ID']['input'];
  activitiesSortOrder?: InputMaybe<SortOrder>;
  activitiesLimit?: InputMaybe<Scalars['Int']['input']>;
  activitiesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicCrafterProjectQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', publicProject?: { __typename?: 'PublicProject', short_id: string, name: string, state: ProjectState, craft_type?: CraftType | null, recipient?: string | null, started_at?: string | null, ends_at?: string | null, published_at: string, image?: { __typename?: 'ProductImage', url: string } | null, projectActivities?: { __typename?: 'PublicProjectActivitiesResponse', limit?: number | null, cursor?: string | null, activities: Array<{ __typename?: 'PublicProjectActivity', type: ActivityType, created_at: string, updated_at: string, details?: { __typename?: 'ProjectStateChangeDetails', from: ProjectState, to: ProjectState } | { __typename?: 'ProjectVisibilityChangeDetails', is_public: boolean, published_at?: string | null } | null, note?: { __typename?: 'PublicProjectNote', content: string, rows?: number | null, created_at: string, updated_at: string, images?: Array<{ __typename?: 'ProductImage', url: string }> | null } | null }> } | null, pattern?: { __typename?: 'PublicPattern', name: string, craft_type?: CraftType | null, image?: { __typename?: 'ProductImage', url: string, alt: string } | null } | null } | null } | null };

export type GetWishlistQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetWishlistQuery = { __typename?: 'Query', crafter?: { __typename?: 'CrafterQueries', userWishlist?: { __typename?: 'WishlistResponse', cursor?: string | null, limit?: number | null, wishlist?: Array<{ __typename?: 'WishlistItem', created_at: string, id: string, product_group_identifier?: string | null, sku?: string | null }> | null } | null } | null };

export const LimitedNoteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<LimitedNoteFragment, unknown>;
export const ListProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<ListProjectFragment, unknown>;
export const FullNoteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<FullNoteFragment, unknown>;
export const ProjectQuantityYarnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectQuantityYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]} as unknown as DocumentNode<ProjectQuantityYarnFragment, unknown>;
export const SingleProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SingleProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesSortOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStateChangeDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVisibilityChangeDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesCursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectQuantityYarn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectQuantityYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]} as unknown as DocumentNode<SingleProjectFragment, unknown>;
export const FullYarnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"yarn_weight"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"crochet_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knitting_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<FullYarnFragment, unknown>;
export const CreateReviewMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReviewMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProductReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReviewMutationMutation, CreateReviewMutationMutationVariables>;
export const ProductReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProductReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listReviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body_text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body_text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductReviewsQuery, ProductReviewsQueryVariables>;
export const PatternSuggestionsForYarnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatternSuggestionsForYarn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yarnProductGroupIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patternSuggestionsForYarn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"yarnProductGroupIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yarnProductGroupIdentifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patterns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]} as unknown as DocumentNode<PatternSuggestionsForYarnQuery, PatternSuggestionsForYarnQueryVariables>;
export const CreatePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePostInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments_count"}},{"kind":"Field","name":{"kind":"Name","value":"own_reaction"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reaction_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"love"}},{"kind":"Field","name":{"kind":"Name","value":"in_love"}},{"kind":"Field","name":{"kind":"Name","value":"smile"}},{"kind":"Field","name":{"kind":"Name","value":"cool"}},{"kind":"Field","name":{"kind":"Name","value":"haha"}},{"kind":"Field","name":{"kind":"Name","value":"wow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teaser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site_name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePostMutation, CreatePostMutationVariables>;
export const UpdatePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePostInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"images"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePostMutation, UpdatePostMutationVariables>;
export const DeletePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"post_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePostMutation, DeletePostMutationVariables>;
export const CreateCommunityImageUploadOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCommunityImageUploadOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadImageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImageUploadOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload_endpoint"}},{"kind":"Field","name":{"kind":"Name","value":"file_url"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCommunityImageUploadOptionsMutation, CreateCommunityImageUploadOptionsMutationVariables>;
export const CreateProfileImageUploadOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProfileImageUploadOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadImageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImageUploadOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload_endpoint"}},{"kind":"Field","name":{"kind":"Name","value":"file_url"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProfileImageUploadOptionsMutation, CreateProfileImageUploadOptionsMutationVariables>;
export const SetProfileAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetProfileAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<SetProfileAvatarMutation, SetProfileAvatarMutationVariables>;
export const DeleteProfileAvatarMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProfileAvatarMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProfileAvatarMutationMutation, DeleteProfileAvatarMutationMutationVariables>;
export const CreateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reaction_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"love"}},{"kind":"Field","name":{"kind":"Name","value":"in_love"}},{"kind":"Field","name":{"kind":"Name","value":"smile"}},{"kind":"Field","name":{"kind":"Name","value":"cool"}},{"kind":"Field","name":{"kind":"Name","value":"haha"}},{"kind":"Field","name":{"kind":"Name","value":"wow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"own_reaction"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}},{"kind":"Field","name":{"kind":"Name","value":"post_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCommentMutation, CreateCommentMutationVariables>;
export const UpdateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCommentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"images"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"comment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CreateReactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReactionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReactionMutation, CreateReactionMutationVariables>;
export const DeleteReactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteReactionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteReactionMutation, DeleteReactionMutationVariables>;
export const FollowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Follow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FollowInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"follow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<FollowMutation, FollowMutationVariables>;
export const UnfollowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Unfollow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FollowInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unfollow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<UnfollowMutation, UnfollowMutationVariables>;
export const ReportPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportPostInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ReportPostMutation, ReportPostMutationVariables>;
export const ReportCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCommentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ReportCommentMutation, ReportCommentMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const AcceptTosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptTos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<AcceptTosMutation, AcceptTosMutationVariables>;
export const BlockUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BlockUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BlockInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<BlockUserMutation, BlockUserMutationVariables>;
export const UnblockUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnblockUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BlockInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unblock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<UnblockUserMutation, UnblockUserMutationVariables>;
export const PostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Post"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments_count"}},{"kind":"Field","name":{"kind":"Name","value":"own_reaction"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reaction_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"love"}},{"kind":"Field","name":{"kind":"Name","value":"in_love"}},{"kind":"Field","name":{"kind":"Name","value":"smile"}},{"kind":"Field","name":{"kind":"Name","value":"cool"}},{"kind":"Field","name":{"kind":"Name","value":"haha"}},{"kind":"Field","name":{"kind":"Name","value":"wow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teaser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site_name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PostQuery, PostQueryVariables>;
export const PostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Posts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments_count"}},{"kind":"Field","name":{"kind":"Name","value":"own_reaction"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reaction_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"love"}},{"kind":"Field","name":{"kind":"Name","value":"in_love"}},{"kind":"Field","name":{"kind":"Name","value":"smile"}},{"kind":"Field","name":{"kind":"Name","value":"cool"}},{"kind":"Field","name":{"kind":"Name","value":"haha"}},{"kind":"Field","name":{"kind":"Name","value":"wow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teaser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site_name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PostsQuery, PostsQueryVariables>;
export const CommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Comments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"post_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post_id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reaction_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"love"}},{"kind":"Field","name":{"kind":"Name","value":"in_love"}},{"kind":"Field","name":{"kind":"Name","value":"smile"}},{"kind":"Field","name":{"kind":"Name","value":"cool"}},{"kind":"Field","name":{"kind":"Name","value":"haha"}},{"kind":"Field","name":{"kind":"Name","value":"wow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"own_reaction"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"love"}},{"kind":"Field","name":{"kind":"Name","value":"in_love"}},{"kind":"Field","name":{"kind":"Name","value":"smile"}},{"kind":"Field","name":{"kind":"Name","value":"cool"}},{"kind":"Field","name":{"kind":"Name","value":"haha"}},{"kind":"Field","name":{"kind":"Name","value":"wow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentsQuery, CommentsQueryVariables>;
export const ReactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Reactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetReactionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]} as unknown as DocumentNode<ReactionsQuery, ReactionsQueryVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"followers_count"}},{"kind":"Field","name":{"kind":"Name","value":"following_count"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"is_blocking"}},{"kind":"Field","name":{"kind":"Name","value":"is_following"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const ProfileNameCheckDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileNameCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usernameCheck"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileNameCheckQuery, ProfileNameCheckQueryVariables>;
export const ReadNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notification_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const ReadNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReadNotificationsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const SeenUserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SeenUserNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seenUserNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<SeenUserNotificationsMutation, SeenUserNotificationsMutationVariables>;
export const CrafterProjectCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrafterProjectCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProjectCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListProject"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CrafterProjectCreateMutation, CrafterProjectCreateMutationVariables>;
export const CrafterProjectFileUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrafterProjectFileUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUploadCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUploadCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_identifier"}},{"kind":"Field","name":{"kind":"Name","value":"upload_endpoint"}}]}}]}}]}}]} as unknown as DocumentNode<CrafterProjectFileUploadMutation, CrafterProjectFileUploadMutationVariables>;
export const CrafterProjectUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrafterProjectUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProjectUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CrafterProjectUpdateMutation, CrafterProjectUpdateMutationVariables>;
export const CrafterProjectProgressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrafterProjectProgressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectProgressUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProjectUpdateProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<CrafterProjectProgressUpdateMutation, CrafterProjectProgressUpdateMutationVariables>;
export const UserProjectAssignYarnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserProjectAssignYarn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAssignYarnInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProjectAssignYarn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"yarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProjectAssignYarnMutation, UserProjectAssignYarnMutationVariables>;
export const CrafterCreateSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrafterCreateSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyResponseCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"help_text"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"help_text"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CrafterCreateSurveyMutation, CrafterCreateSurveyMutationVariables>;
export const CrafterSaveSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrafterSaveSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseSaveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyResponseSave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<CrafterSaveSurveyMutation, CrafterSaveSurveyMutationVariables>;
export const UserYarnCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserYarnCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"YarnCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userYarnCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullYarn"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"yarn_weight"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"crochet_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knitting_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<UserYarnCreateMutation, UserYarnCreateMutationVariables>;
export const UserYarnUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserYarnUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"YarnUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userYarnUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullYarn"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"yarn_weight"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"crochet_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knitting_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<UserYarnUpdateMutation, UserYarnUpdateMutationVariables>;
export const UserYarnDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserYarnDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userYarnDeleteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userYarnDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userYarnDeleteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UserYarnDeleteMutation, UserYarnDeleteMutationVariables>;
export const AddToWishlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToWishlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productGroupIdentifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wishlistAddProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"product_group_identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productGroupIdentifier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_group_identifier"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]}}]}}]} as unknown as DocumentNode<AddToWishlistMutation, AddToWishlistMutationVariables>;
export const RemoveFromWishlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveFromWishlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wishlistRemoveProductId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wishlistRemoveProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wishlistRemoveProductId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveFromWishlistMutation, RemoveFromWishlistMutationVariables>;
export const CustomerAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopify"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"store_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerAccessTokenQuery, CustomerAccessTokenQueryVariables>;
export const StarterDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StarterData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetNotificationsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"unseen"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"toc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followers_count"}},{"kind":"Field","name":{"kind":"Name","value":"following_count"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StarterDataQuery, StarterDataQueryVariables>;
export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Notifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"unseen"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"read_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"actor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceable_type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceable_id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"post_id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const CountryConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countryConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefront"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpoint"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"publicAccessToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeEndpoint"}}]}}]}}]}}]} as unknown as DocumentNode<CountryConfigsQuery, CountryConfigsQueryVariables>;
export const CustomerContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pattern"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<CustomerContentQuery, CustomerContentQueryVariables>;
export const PostCountersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PostCounters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"galleryContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qaContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContextInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gallery"},"name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"galleryContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"qa"},"name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qaContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<PostCountersQuery, PostCountersQueryVariables>;
export const LoyaltyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoyaltyQuery, LoyaltyQueryVariables>;
export const PatternBySkuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatternBySku"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlVersion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactUUID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patternBySku"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlVersion"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<PatternBySkuQuery, PatternBySkuQueryVariables>;
export const GetCountriesDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountriesDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeEndpoint"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_switcher_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"is_international"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<GetCountriesDataQueryQuery, GetCountriesDataQueryQueryVariables>;
export const BingoIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BingoId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryConfigInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryConfigInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bingoId"}}]}}]}}]} as unknown as DocumentNode<BingoIdQuery, BingoIdQueryVariables>;
export const CrafterProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrafterProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"states"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectState"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"states"},"value":{"kind":"Variable","name":{"kind":"Name","value":"states"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListProject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CrafterProjectsQuery, CrafterProjectsQueryVariables>;
export const CrafterProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrafterProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitiesSortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitiesLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitiesCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notesCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SingleProject"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitedNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullNote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectQuantityYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SingleProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitedNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesSortOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStateChangeDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVisibilityChangeDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notesCursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectQuantityYarn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<CrafterProjectQuery, CrafterProjectQueryVariables>;
export const CrafterYarnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrafterYarn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userYarn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullYarn"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"yarn_weight"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"crochet_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knitting_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<CrafterYarnQuery, CrafterYarnQueryVariables>;
export const CrafterYarnsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrafterYarns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"YarnFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"YarnSortBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userYarns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterItems"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"yarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullYarn"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"yarn_weight"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"crochet_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knitting_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<CrafterYarnsQuery, CrafterYarnsQueryVariables>;
export const CrafterYarnSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrafterYarnSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"YarnSortBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suggestedCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userYarnSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"suggestedCursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suggestedCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggested"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterItems"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullYarn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterItems"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yarns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullYarn"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullYarn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Yarn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"yarn_weight"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"crochet_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knitting_gauge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"stitches"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"in_use"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<CrafterYarnSuggestionsQuery, CrafterYarnSuggestionsQueryVariables>;
export const CrafterPatternsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrafterPatterns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PatternFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PatternSortBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPatterns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterItems"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patterns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CrafterPatternsQuery, CrafterPatternsQueryVariables>;
export const PublicCrafterProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicCrafterProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitiesSortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitiesLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitiesCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shortId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}},{"kind":"Field","name":{"kind":"Name","value":"projectActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitiesSortOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStateChangeDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectVisibilityChangeDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"published_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"craft_type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicCrafterProjectQuery, PublicCrafterProjectQueryVariables>;
export const GetWishlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWishlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userWishlist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"wishlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_group_identifier"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWishlistQuery, GetWishlistQueryVariables>;